import {yupResolver} from "@hookform/resolvers/yup";
import {Button, TextField, Stack} from "@mui/material";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import useApiRequest from "../../hooks/useApiRequest";
import {useNavigate} from "react-router-dom";

const schema = yup.object().shape({
  name: yup
    .string()
    .required("El nombre es obligatorio")
    .max(255, "Máximo 255 caracteres")
    .matches(/^[a-zA-Z0-9: ]*$/, "Solo se permiten letras, números y dos puntos"),

  description: yup.string().required("La descripción es obligatoria").max(255, "Máximo 255 caracteres")
});

const ScopeForm = ({isNew, refreshData, setIsEditing, initialScopeData}) => {
  const navigate = useNavigate();
  const {loading, create, update} = useApiRequest({baseUrl: `/scopes`, resource: "scopes"});

  const handleSave = async (data) => {
    try {
      let result;

      if (isNew) {
        result = await create(data);
      } else {
        result = await update(initialScopeData.id, data);
      }

      if (result?.success) {
        await refreshData();
        setIsEditing(false);
        if (isNew) {
          navigate("/scope-form", {state: {id: result.data.id}});
        }
      }
    } catch (error) {
      console.error("Error al guardar cambios:", error);
    }
  };

  const {
    register,
    handleSubmit,
    formState: {errors}
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialScopeData
  });

  const onSubmit = (data) => {
    handleSave(data);
  };

  return (
    <Stack direction="column" spacing={2} minWidth={"300px"}>
      <TextField
        label="Nombre"
        {...register("name")}
        multiline
        slotProps={{htmlInput: {maxLength: 255}}}
        error={!!errors.name}
        helperText={errors.name?.message}
        variant="outlined"
      />
      <TextField
        label="Descripción"
        {...register("description")}
        multiline
        slotProps={{htmlInput: {maxLength: 255}}}
        error={!!errors.description}
        helperText={errors.description?.message}
        variant="outlined"
      />
      <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)} disabled={loading}>
        {isNew ? "Crear" : "Guardar"}
      </Button>
    </Stack>
  );
};

export default ScopeForm;
